<template>
  <populate-form
    :formTitle="FocusedStore.store_name+'＿分店資訊維護'"
    fkey="si01"
    ref="StoreInfoForm"
    populateOptionVar="storeFormItems"
    formDataObjVar="FocusedStore"
    :validatePrompt="false"
    :parentVue="this"
  ></populate-form>
</template>

<script>

export default {
  name: 'StoreInfo',
  components: {

  },
  props: {
    'cbSave':{
      type:Function,
      default: function () {
        return
      }
    },
    'cbCancel':{
      type:Function,
      default: function () {
        return
      }
    },
    'parentVue':Object,
  },
  data: function () {
    return {
      storeFormItems:[
        {
          'componentType':'span',
          'akey':'span1',
          'col':2,
          'placeholder':'分店名稱',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'store_name',
          'col':4,
          'placeholder':'分店名稱',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span2',
          'col':2,
          'placeholder':'分店編碼',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'store_id',
          'col':4,
          'placeholder':'分店編碼',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span3',
          'col':2,
          'placeholder':'分店類型',
          'title':'',
        },
        {
          'componentType':'b-form-select',
          'akey':'is_super_manage',
          'dataOptions':[{'value':0,'text':'分店'},{'value':1,'text':'總管理店'}],
          'col':4,
          'placeholder':'分店類型',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span4',
          'col':2,
          'placeholder':'服務狀態',
          'title':'',
        },
        {
          'componentType':'b-form-radio-group',
          'akey':'is_open',
          'dataOptions':[{'value':0,'text':'關閉中'},{'value':1,'text':'服務中'}],
          'col':4,
          'placeholder':'服務狀態',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span5',
          'col':2,
          'placeholder':'店負責人',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'store_representative',
          'col':4,
          'placeholder':'店負責人',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span6',
          'col':2,
          'placeholder':'聯絡方式',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'store_contact_info',
          'col':4,
          'placeholder':'聯絡方式',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span7',
          'col':2,
          'placeholder':'地址',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'store_address',
          'col':10,
          'placeholder':'地址',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span8',
          'col':2,
          'placeholder':'店長',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'account_name',
          'col':4,
          'placeholder':'店長',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span9',
          'col':2,
          'placeholder':'店長帳號',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'account',
          'col':4,
          'placeholder':'email',
          'disabled':true,
        },
        {
          'componentType':'span',
          'akey':'span10',
          'col':2,
          'placeholder':'附近地點描述',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'loc_desc',
          'col':4,
          'placeholder':'附近地點描述',
          'disabled':true,
        },
        {
          'componentType':'span',
          'col':2,
          'placeholder':'管理手機',
          'title':'',
        },
        {
          'componentType':'text',
          'akey':'adm_tel',
          'col':4,
          'placeholder':'密碼通知簡訊手機',
          'disabled':true,
        },
        {
          'componentType':'iframe-map',
          'akey':'loc',
          'col':12,
          'loc': {
              'latitude': 25.0, //this.FocusedStore.latitude,
              'longitude': 121.5, // this.FocusedStore.longitude,
              'zIndex':16,
            },
          'src':"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.4998226846487!2d121.53963151500665!3d25.051042983964333!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442abde6fa9ef8d%3A0x798d39e9771c73f9!2zMTA0OTHlj7DljJfluILkuK3lsbHljYDpgbzlr6fooZc3MuiZnw!5e0!3m2!1szh-TW!2stw!4v1546934862331"
        },
        {
          'componentType':'b-button',
          'akey':'button_cancel',
          'col':6,
          'placeholder':'返回',
          'title':'',
          'execCallback':this.cbCancel
        },
        {
          'componentType':'b-button',
          'akey':'button_save',
          'col':6,
          'placeholder':'更新',
          'title':'',
          'execCallback':this.saveStore
        },
      ],
    }
  },
  methods: {
    saveStore () {
      // 暫時不提供當作沒發生= =
      this.$bus.fnShowInfo('目前不提供在此修改分店')
      this.cbCancel()
    },
  },
  computed: {
    parentRef () {
      if (this.parentVue) {
        return this.parentVue
      }
      else {
        return this
      }
    },
    FocusedStore () {
      return this.parentRef['FocusedStore']?this.parentRef['FocusedStore']:{}
    }
  },
  created() {
    
  },
  mounted() {
    for (let i=0;i<this.storeFormItems.length;i++) {
      if (this.storeFormItems[i].akey === 'loc') {
        this.storeFormItems[i].loc = {
          'latitude': this.FocusedStore.latitude,
          'longitude': this.FocusedStore.longitude,
          'zIndex':this.storeFormItems[i].loc.zIndex
        }
        return
      }
    }
  },
  watch: {
    
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
